<!-- report_post_list.vue -->
<template>
  <div class="w-100 h-100">
    <div class="header-individual" :class="header_notification ? 'header-notification-space' : ''" v-show="checkList.length > 0">
      <div class="check-wrap">
        <div class="check-parts" style="color: #666">{{ checkList.length }}件の投稿を選択中</div>
        <div class="check-parts pointer" @click="report_id == 'demo' ? '' : deletePost()" :style="report_id == 'demo' ? 'opacity:0.5' : ''">
          <i class="el-icon-delete" style="font-size: 14px"></i>レポートから削除
        </div>
        <costSetting :report_id="report_id" :sns_type="sns_type" :index="'10000'" :checkList="checkList" :type="'media_bundle'" @syncCost="syncCost" @reload="reload" />
      </div>
    </div>

    <div class="report-done-switch influencer">
      <div v-if="result_count >= 0" class="report-influencer-breadcrumb flex-row">
        <span class="report-influencer-breadcrumb-num">{{ result_count }}</span>
        <span>件の投稿</span>
        <div class="flex-row" style="margin-left: 30px">
          <div class="new-tag" style="margin-right:5px">NEW</div>
          <div style="font-size:11px">コストやインサイト数値の編集がスプレッドシートライクに行えるようになりました。</div>
        </div>
      </div>
      <div class="flex-space"></div>
      <reportDisplayButton :sns_type="sns_type" :list_type="'post'" />
    </div>
    <div class="data-table-media-wrap report-post-list">
      <table class="data-table-media">
        <tr v-if="!mounted" class="new-table-title w-100">
          <div class="placeholder-item width100"></div>
          <div class="placeholder-item width200"></div>
          <div class="placeholder-item width100"></div>
          <div class="placeholder-item width100"></div>
          <div class="placeholder-item width100"></div>
        </tr>

        <tr v-else class="new-table-title">
          <div class="new-table-item checkbox-all">
            <div class="checkbox_inner" :class="check_list_status" @click="checkAll('auto')"></div>
            <el-dropdown trigger="click" placement="bottom-start" @visible-change="checkAll_dropdown = $event">
              <span style="height:20px">
                <div class="checkbox-select-wrap report" :class="checkAll_dropdown ? 'hover' : ''"><font-awesome-icon icon="caret-down" /></div>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="checkAll('select')">表示中を全て選択({{ post_list ? post_list.length : "-" }}件)</el-dropdown-item>
                <el-dropdown-item @click.native="checkAll('unselect')">表示中を全て選択解除({{ post_list ? post_list.length : "-" }}件)</el-dropdown-item>
                <el-dropdown-item @click.native="checkAll('selectAll')" divided>レポート内の投稿を全て選択({{ all_post.length }}件)</el-dropdown-item>
                <el-dropdown-item @click.native="checkAll('unselectAll')" v-if="checkList.length > 0">選択中を全て解除({{ checkList.length }}件)</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <draggable tag="div" class="flex-row h-100 w-100" v-model="column_list">
            <div
                v-for="(column, column_index) in column_list"
                :key="column.column"
                v-show="item[column.column] !== false"
                class="new-table-item"
                :class="[column.width, column_index == 0 ? 'title-sticky' : '', column_index < 2 ? 'nohover' : '']"
                @click="canSort(column_index, column) ? sortBy(column.column) : ''"
            >
              <div
                  v-if="column.type === 'media_and_if'"
                  class="new-table-title-media-if flex-row w-100"
              >
                <div class="new-table-title-media-if-thumb-wrap">
                  <span :class="[sort_key == column.column ? 'new-table-title-sort' : '']">
                    {{ column.title }}
                    <font-awesome-icon
                        v-if="sort_key == column.column"
                        :icon="['fas', sort_key == column.column && sort_order == 'asc' ? 'arrow-up' : sort_key == column.column && sort_order == 'desc' ? 'arrow-down' : '']"
                        style="margin-left:3px;"
                    />
                  </span>
                </div>
              </div>
              <span v-else :class="[sort_key == column.column ? 'new-table-title-sort' : '', column_index == 0 ? 'new-table-title-0' : '']">
                {{ column.title }}
                <font-awesome-icon
                    v-if="sort_key == column.column"
                    :icon="['fas', sort_key == column.column && sort_order == 'asc' ? 'arrow-up' : sort_key == column.column && sort_order == 'desc' ? 'arrow-down' : '']"
                    style="margin-left:3px;"
                />
              </span>
            </div>
          </draggable>
        </tr>

        <tbody>
<!--        <tr class="new-table-content" v-for="(post, row_index) in post_list" :key="post.media_id">-->
          <tr class="new-table-content" v-for="(post, row_index) in post_list" :key="post._post_id">
          <div class="new-table-item checkbox">
<!--            <input type="checkbox" class="checkbox-original" v-model="checkList" :value="post.media_id" :id="post.media_id + 'checkbox'" />-->
<!--            <label class="checkbox_inner" :for="post.media_id + 'checkbox'"> </label>-->
            <input type="checkbox" class="checkbox-original" v-model="checkList" :value="post._post_id" :id="post._post_id + 'checkbox'" />
            <label class="checkbox_inner" :for="post._post_id + 'checkbox'"> </label>
          </div>

          <component
              :is="postValueComponent || 'reportPostValue'"
              v-for="(column, column_index) in column_list"
              :key="column.column"
              v-show="item[column.column] !== false"
              class="new-table-item"
              :class="[
                column.width,
                isCellEditable(column, post) ? 'editable' : '',
                column_index == 0 ? 'sticky' : '',
                active_cell == row_index + '-' + column_index ? 'active' : ''
              ]"
              :column="column.column"
              :report_id="report_id"
              :media_id="post._post_id"
              :id="row_index + '-' + column_index"
              :ref="'value-' + row_index + '-' + column_index"
              :index="row_index"
              :value="column.type === 'caption'
                ? { caption: post[column.column], account_name: post.account_name }
                : post[column.column]"
              :type="column.type"
              :editable="isCellEditable(column, post)"
              :sns_type="sns_type"
              @openInfluencer="openInfluencer"
              @openMedia="openMedia"
              @finishEdit="finishEdit"
              @syncValue="syncValue"
              @updateValue="updateValue"
              @click.native="activeCell(row_index, column_index)"
              @dblclick.native="isCellEditable(column, post) ? openCell() : ''"
          />
        </tr>
        </tbody>

        <infinite-loading spinner="spiral" :identifier="infiniteId" @infinite="infiniteHandler">
          <div slot="no-more"></div>
          <div slot="no-results"></div>
        </infinite-loading>
      </table>
    </div>

    <reportPostDrawer
        v-if="mounted && !loading && !nodata && post_list[row_index]"
        :report_id="report_id"
        :post_list="target_post"
        :influencer="post_list[row_index].influencer"
        :post_drawer="post_drawer"
        @closeMedia="closeMedia"
        @openInfluencer="openInfluencer"
    />
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const loadReportPostAPI = root + "/api/report/load_report_post";
const deletePostAPI = root + "/api/report/delete_post";

import reportPostValue from "./report_post_value.vue";
import reportPostDrawer from "./report_post_drawer.vue";
import reportDisplayButton from "./report_display_button.vue";
import costSetting from "./cost_setting.vue";

export default {
  name: "reportPostList",
  props: {
    report_id: { type: [String, Number], required: true },
    sns_type: { type: String, default: "instagram" },
    postValueComponent: { type: [Object, Function], default: null },
  },
  components: {
    reportPostValue,
    reportPostDrawer,
    reportDisplayButton,
    costSetting,
  },
  data() {
    return {
      mounted: false,
      loading: false,
      checkList: [],
      checkAll_dropdown: false,
      all_post: [],
      post_list: [],
      column_list: [],
      row_index: 0,
      column_index: -1,
      edit_cell: "",
      infiniteId: +new Date(),
      requestId: +new Date(),
      count: 0,
      sort_key: "followers_count",
      sort_order: "desc",
      result_count: -1,
      nodata: false,
      post_drawer: false,
      influencer_drawer: false,
      cost_type: "unit",
      cost_postup: false,
      // この画面でいいね数を入力した投稿。ページ遷移(コンポーネント破棄)まで再編集可
      sessionEditableLikePostIds: {},
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    header_notification() {
      return this.$store.state.header_notification;
    },
    target_post() {
      return { 0: this.post_list[this.row_index] };
    },
    active_cell() {
      return this.row_index + "-" + this.column_index;
    },
    check_list_status() {
      if (this.post_list.length > 0) {
        let checkCount = 0;
        for (let i = 0; i < this.post_list.length; i++) {
          for (let ii = 0; ii < this.checkList.length; ii++) {
            if (this.post_list[i]._post_id == this.checkList[ii]) checkCount += 1;
          }
        }
        if (checkCount == this.post_list.length) return "all";
        if (checkCount > 0) return "some";
        return "none";
      }
      return "none";
    },
    item() {
      const st = (this.sns_type || "").toString().toLowerCase() === "tiktok"
          ? "tiktok"
          : ((this.sns_type || "").toString().toLowerCase() === "x" || (this.sns_type || "").toString().toLowerCase() === "twitter")
              ? "x"
              : "instagram";

      return this.$store.state.report_item_map?.post?.[st] || {};
    },
    user_token() {
      return this.$store.state.user_token;
    },
  },
  mounted() {
    this.addKeyDown();
    this.$nextTick(() => {
      this.infiniteId += 1;
    });
  },
  methods: {
    canSort(column_index, column) {
      if (column_index <= 1) return false;
      const unsortTypes = new Set(["diff", "refer", "refer_percent", "caption", "media_and_if"]);
      if (unsortTypes.has(column.type)) return false;
      return true;
    },

    /**
     * セル単位の編集可否。
     * Instagramのいいね数: 非表示(null/-1)、またはこの画面で入力済みの投稿は編集可。
     */
    isCellEditable(column, post) {
      if (!column) return false;
      if (column.column === "like_count") {
        const sns = (this.sns_type || "").toString().toLowerCase();
        if (sns !== "instagram") return false;
        const postId = post?._post_id;
        if (postId && this.sessionEditableLikePostIds[postId]) return true; // 同一画面で入力済みは再編集可
        const v = post?.[column.column];
        return v === null || v === undefined || v === "" || Number(v) < 0; // 非表示(null/-1)のみ編集可
      }
      return !!column.editable;
    },

    normalizePostList(list) {
      return (list || []).map((p) => {
        const id = p.media_id || p.tweet_id || p.video_id || (p.influencer && (p.influencer.media_id || p.influencer.tweet_id || p.influencer.video_id));
        const normalized = { ...p, _post_id: id };
        if (
          Object.prototype.hasOwnProperty.call(normalized, "like_count") &&
          (normalized.like_count === "" || Number(normalized.like_count) < 0)
        ) {
          normalized.like_count = null; // 非表示値を正規化（-1 → null）
        }
        return normalized;
      });
    },
    normalizeAllPost(allPost, postList) {
      if (Array.isArray(allPost) && allPost.length > 0) return allPost;
      return (postList || []).map((p) => p._post_id).filter(Boolean);
    },

    infiniteHandler($state) {
      this.nodata = false;
      this.loading = true;
      this.axios.cancel(this.requestId);
      this.requestId += 1;
      this.$refs.xscroll && (this.$refs.xscroll.style.width = this.$refs.xscroll.parentElement.clientWidth + "px");

      const params = new URLSearchParams();
      params.append("report_id", this.report_id == "demo" ? 1 : this.report_id);
      params.append("count", this.count);
      params.append("sort_key", this.sort_key);
      params.append("sort_order", this.sort_order);
      params.append("token", this.report_id == "demo" ? "demo" : this.token);
      params.append("user_token", this.user_token);
      params.append("sns_type", this.sns_type);

      this.axios
          .post(loadReportPostAPI, params, { requestId: this.requestId })
          .then((response) => {
            let postList = this.normalizePostList(response.data.post_list);
            // 更新値を反映させる為に各タブ１ページ目読み込み時のみキャッシュ更新。２ページ目(21件以降)以降はキャッシュを利用
            if (this.count === 0) {
              this.$store.dispatch("clearReportPostOverrides", {
                report_id: this.report_id,
                sns_type: this.sns_type,
              });
            }
            const rid = String(this.report_id ?? "");
            const sns = (this.sns_type ?? "").toString().toLowerCase() === "tiktok"
                ? "tiktok"
                : ((this.sns_type ?? "").toString().toLowerCase() === "x" || (this.sns_type ?? "").toString().toLowerCase() === "twitter")
                    ? "x"
                    : "instagram";

            const overrideMap =
                this.$store.state.report_post_override_map?.[rid]?.[sns] || {};

            postList = postList.map((p) => {
              const ov = overrideMap?.[p._post_id];
              return ov ? { ...p, ...ov } : p;
            });

            const allPost = this.normalizeAllPost(response.data.all_post, postList);

            if (this.count == 0) {
              this.result_count = response.data.result_count;
              this.column_list = response.data.column_list || [];
              this.post_list = postList;
              this.all_post = allPost;

              // SNS別デフォルトを column_list.show から反映
              this.$store.dispatch("setReportColumnList", {
                sns_type: this.sns_type,
                list_type: "post",
                column_list: this.column_list,
              });
              this.$store.dispatch("initReportItemsFromColumnList", {
                sns_type: this.sns_type,
                list_type: "post",
                column_list: this.column_list,
              });

              this.count += 20;
              $state.loaded();
            } else {
              this.post_list = this.post_list.concat(postList);
              this.count += 20;
              $state.loaded();
            }

            if (this.count >= this.result_count) $state.complete();
            if (this.result_count == 0) this.nodata = true;

            this.loading = false;
            this.mounted = true;
          })
          .catch(() => {
            this.loading = false;
          });
    },

    reload() {
      this.count = 0;
      this.loading = true;
      this.post_list = [];
      this.checkList = [];
      this.infiniteId += 1;
    },

    sortBy(sort_key) {
      if (this.sort_key == sort_key) {
        this.sort_order = this.sort_order == "desc" ? "asc" : "desc";
      } else {
        this.sort_key = sort_key;
        this.sort_order = "desc";
      }
      this.reload();
    },

    checkAll(type) {
      if (type == "auto") {
        if (this.check_list_status == "all") type = "unselect";
        if (this.check_list_status == "some") type = "unselect";
        if (this.check_list_status == "none") type = "select";
      }
      if (type == "select") {
        for (let i = 0; i < this.post_list.length; i++) {
          // if (!this.checkList.includes(this.post_list[i].media_id)) this.checkList.push(this.post_list[i].media_id);
          const id = this.post_list[i]._post_id;
          if (id && !this.checkList.includes(id)) this.checkList.push(id);

        }
      } else if (type == "unselect") {
        for (let i = 0; i < this.post_list.length; i++) {
          // const id = this.post_list[i].media_id;
          const id = this.post_list[i]._post_id;
          if (this.checkList.includes(id)) {
            const index = this.checkList.indexOf(id);
            this.checkList.splice(index, 1);
          }
        }
      } else if (type == "selectAll") {
        this.checkList = [];
        this.checkList = this.checkList.concat(this.all_post);
      } else if (type == "unselectAll") {
        this.checkList = [];
      }
    },

    addKeyDown() {
      document.addEventListener("keydown", this.onKeyDown);
    },
    removeKeyDown() {
      document.removeEventListener("keydown", this.onKeyDown);
    },

    onKeyDown(event) {
      if (event.key == "Tab" || event.key == "ArrowUp" || event.key == "ArrowDown") event.preventDefault();
      if (event.key == "ArrowUp" && this.row_index > 0) this.row_index -= 1;
      if (event.key == "ArrowDown" && this.row_index < this.result_count - 1) this.row_index += 1;

      if (event.key == "ArrowLeft" && this.column_index > 1) {
        for (let i = this.column_index; i >= 0; i--) {
          if (this.item[this.column_list[i - 1]?.column] !== false) {
            this.column_index = i - 1;
            break;
          }
        }
      }

      if ((event.key == "ArrowRight" || event.key == "Tab") && this.column_index < this.column_list.length - 1) {
        for (let i = this.column_index; i < this.column_list.length; i++) {
          if (this.item[this.column_list[i + 1]?.column] !== false) {
            this.column_index = i + 1;
            break;
          }
        }
      }

      if (event.key == "Enter") this.openCell();
      if (event.key == "Backspace") this.openCell(event.key);
      if (event.key.match(/[0-9]/)) this.openCell(event.key);
      this.scrollView();
    },

    scrollView() {
      if (this.active_cell) {
        const el = document.getElementById(this.active_cell);
        if (!el) return;
        el.scrollIntoView({
          behavior: "instant",
          block: "nearest",
          inline: "nearest",
        });
      }
    },

    activeCell(row_index, column_index) {
      if (column_index > 0) {
        this.row_index = row_index;
        this.column_index = column_index;
      }
      if (this.column_index == 1) this.openCell();
    },

    openCell(value) {
      if (this.report_id == "demo") {
        this.$message({
          message: "デモでは編集できません。",
          type: "error",
          offset: 7,
          showClose: true,
        });
      } else {
        const column = this.column_list[this.column_index];
        const post = this.post_list[this.row_index];
        if (this.isCellEditable(column, post)) {
          this.$refs["value-" + this.active_cell]?.[0]?.openCell?.(value);
          this.removeKeyDown();
        } else if (column?.column == "caption") {
          this.openMedia();
        }
      }
    },

    syncValue(index, edit_value, column) {
      if (!this.post_list[index]) return;

      // ローカル反映
      this.$set(this.post_list[index], column, edit_value);

      // 差分保持（タブ移動しても戻らないように）
      const post_id = this.post_list[index]._post_id;
      if (post_id) {
        this.$store.dispatch("setReportPostOverride", {
          report_id: this.report_id,
          sns_type: this.sns_type,
          post_id,
          column,
          value: edit_value,
        });
        if (column === "like_count") {
          this.$set(this.sessionEditableLikePostIds, post_id, true); // ページ遷移まで再編集可
        }
      }
    },

    updateValue(index, new_post_data) {
      if (!this.post_list[index]) return;

      const prev = this.post_list[index];
      const merged = { ...prev, ...(new_post_data || {}) };

      if (!merged._post_id) merged._post_id = prev._post_id;

      if (
        Object.prototype.hasOwnProperty.call(merged, "like_count") &&
        (merged.like_count === null ||
          merged.like_count === undefined ||
          merged.like_count === "" ||
          Number(merged.like_count) < 0)
      ) {
        merged.like_count = null; // 非表示値を正規化（-1 → null）
      }

      this.post_list.splice(index, 1, merged);
    },


    finishEdit(presskey) {
      if (presskey == "enter") {
        if (this.row_index < this.result_count - 1) this.row_index += 1;
        this.$nextTick(() => {
          this.scrollView();
        });
      }
      this.addKeyDown();
    },

    openMedia(index) {
      if (index >= 0) this.row_index = index;
      this.post_drawer = true;
    },

    closeMedia() {
      this.post_drawer = false;
    },

    openInfluencer(account_name, sns_type) {
      const st = (sns_type ?? this.sns_type ?? "").toString();
      const sns = (st === "x") ? "twitter" : st;
      this.$emit("openInfluencer", account_name, sns);
    },

    deletePost() {
      const h = this.$createElement;
      this.$msgbox({
        title: "投稿削除",
        type: "warning",
        message: h("p", null, [
          h("span", null, "レポートから投稿を削除するとトラッキング対象から除外されます"),
          h("br", null, ""),
          h("span", null, "削除後は再度投稿追加することでトラッキング対象に戻すことができます"),
        ]),
        customClass: "report-delete",
        showCancelButton: true,
        confirmButtonText: "削除",
        confirmButtonClass: "danger",
        cancelButtonText: "キャンセル",
      }).then(() => {
        const params = new URLSearchParams();
        params.append("report_id", this.report_id);
        params.append("media_list", JSON.stringify(this.checkList));
        params.append("sns_type", this.sns_type);
        params.append("token", this.token);

        this.axios.post(deletePostAPI, params).then(() => {
          this.reload();
          this.$emit("loadReportDetail");
          this.$message({
            type: "success",
            offset: 7,
            showClose: true,
            message: "投稿を削除しました",
          });
        });
      });
    },

    syncCost() {
      this.checkList = [];
      this.checkAll_val = false;
      this.reload();
    },
  },

  beforeDestroy() {
    this.removeKeyDown();
  },
};
</script>
